import { AddressType } from '@Core/enums/AddressType';
import { InterfaceStatusEnum } from '@Core/enums/interface-status.enum';

export interface PolicyContext {
  AccountId: string; // TODO: Remove me
  PolicyId: string;
}

export enum PolicyIntegrity {
  UnratedSuspended = 0,
  RatedSuspended = 1,
  Committed = 2,
}

export const PRS_RERATE_FOR_SYNC = 'Please Re-Rate for policy to sync';
export const PRS_RERATE = 'Please Re-Rate the Policy';
export const PRS_NOT_RATED = 'Not Rated';
export const PRS_RATING_FAILED_HEADER = 'Policy was not successfully rated';
export const PRS_RATING_FAILED_NOTE = 'Please review errors tab';

export enum RatingDisplayEnum {
  RERATE_FOR_SYNC,
  RERATE,
  NOT_RATED,
  RATING_FAILED,
  RATING_SUCCESS,
  NO_ACTION,
}

export enum InterfaceStatus {
  Successful = InterfaceStatusEnum.NUMBER_0,
  Pending = InterfaceStatusEnum.NUMBER_1,
  Failed = InterfaceStatusEnum.NUMBER_2,
}

/** a PolicyAPI policy (detail) entity */
export interface SCPPolicy {
  accountId: string;
  accountUID: number;
  activeTransactionId: number;
  address_1: string;
  address_2: string;
  cancellationDate?: Date;
  city: string;
  commitDate?: Date;
  committedBy: string;
  createdBy: string;
  creationDate: Date;
  dba: string;
  email: string;
  endorsementEffectiveDate: Date;
  expirationDate: Date;
  fax: string;
  id: string;
  inceptionDate: Date;
  insuredName: string;
  policyIntegrity: PolicyIntegrity | null;
  interfaceStatus: InterfaceStatus | null;
  isPolicy: boolean;
  issueDate: Date;
  lastModifiedBy: string;
  lastModifiedDate: Date;
  lob: string;
  nextInterimAuditTransactionDate: Date;
  phone: string;
  policyDescription: string;
  policyNumber: string;
  policyPrimaryStatus: string;
  policyVersion: string;
  premium: number;
  producerId: string; //rename to producerId
  producerName: string;
  productId: number;
  productName: string;
  quoteNumber: string;
  quoteVersion: string;
  ratingCompanyId: string;
  ratingState: string;
  state: string;
  storageId: string;
  subjectToAudit: string[];
  transactionDescription: string;
  type: string;
  writtenPremium: number;
  zipCode: string;

  // non-api
  isFavorite: boolean;
  isRecent: boolean;
  producerAddress?: PolicyAddress;
  uw?: string;
  version?: string;
}

export interface PolicyFieldHelp {
  fieldName: string;
  helpText: string;
  error: boolean;
  errorText: string;
}

export interface PolicyAddress {
  address1: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
  type: AddressType;
}

export interface PolicyChartItem {
  kind: string;
  share: number;
  color: string;
}

export interface RatingChartItem {
  chartItems: PolicyChartItem[];
  progressKey: string;
}

export enum UiPolicyIntegrity {
  POLICY_NOT_RATED = 0,
  POLICY_RATED = 1,
  POLICY_COMMITTED = 2,
}
